const enum ProductFieldsForUpdateEnum {
    PRICE = 'price',
    SALE_PRICE = 'salePrice',
    BALANCE = 'balance',
    PROMO_PRICE = 'promoPrice'
}

export { ProductFieldsForUpdateEnum };